<template>
	<div>
	<div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌 대학교육 서비스</div>
                <div class="button"><a href="//img.eduwill.net/resources/b2b/dev/에듀윌_대학 위탁교육 서비스.pdf"
                        target="_blank">브로슈어 다운로드</a></div>
                <div class="ico-hand"></div>
            </div>
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden" @click="showCounsel('01')"><a href="#" class="circle_counsel">맞춤<br>상담</a>
    </div>
		<sub-header bizCd="01"/>
		<div class="sub_visual sub02">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">대학 온라인 취업교육</div>
                    <div class="comment">20대가 가장 사랑하는 공무원 취업1위 에듀윌.<br>공무원·취업교육에 특화된 맞춤형 교육과정을 만나보세요.</div>
                    <div class="action pc_hidden">
                        <div><a href="//img.eduwill.net/resources/b2b/dev/에듀윌_대학 위탁교육 서비스.pdf"
                        target="_blank" class="btn-1">대학 브로슈어<i class="icon icon-arrow"></i></a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <div class="sub_tit">교육과정</div>
                    <div class="con">
                        <div class="txt">지금 가장 뜨겁게 부상 중인 대학별 선호과정을 확인하세요.</div>

                        <div class="course_list">
                            <div class="course_box h209">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-public.png"
                                                alt="공기업 취업" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-public@3x.png"
                                                alt="공기업 취업" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">공기업 취업</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 한국철도공사 / 한국전력공사</li>
                                            <li>・ 한국수력원자력 / 한국수자원공사</li>
                                            <li>・ 서울교통공사 / 부산교통공사</li>
                                            <li>・ 국민건강보험공단</li>
                                            <li>・ 공기업 자기소개서 &amp; 면접</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h209">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-suitcase.png"
                                                alt="대기업 취업" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-suitcase@3x.png"
                                                alt="대기업 취업" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">대기업 취업</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list">
                                            <li>・ 삼성그룹 GSAT</li>
                                            <li>・ 취업 자소서&면접</li>
                                            <li>・ LG그룹 인적성 </li>
                                            <li>・ 제약・바이오</li>
                                            <li>・ CJ그룹 CAT </li>
                                            <li>・ 취업 상식</li>
                                            <li>・ SK그룹 SKCT </li>
                                            <li>・ 금융권 취업</li>
                                            <li>・ 현대그룹 HKCT</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h209">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-ncs.png"
                                                alt="NCS" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-ncs@3x.png"
                                                alt="NCS" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">NCS</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list">
                                            <li>・ 수리 영역</li>
                                            <li>・ 대인관계 능력</li>
                                            <li>・ 비수리 영역</li>
                                            <li>・ 자기개발 능력</li>
                                            <li>・ 의사소통 능력</li>
                                            <li>・ 자원관리 능력</li>
                                            <li>・ 조직이해 능력</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h398">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-license.png"
                                                alt="취업스펙 자격증" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-license@3x.png"
                                                alt="취업스펙 자격증" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">취업스펙 자격증</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 한국사능력검정 </li>
                                            <li>・ 컴퓨터활용능력 1,2급</li>
                                            <li>・ 정보처리기사</li>
                                            <li>・ 워드프로세서</li>
                                            <li>・ KBS한국어,글쓰기</li>
                                            <li>・ 매경TEST</li>
                                            <li>・ 한경TESAT</li>
                                            <li>・ 한자시험</li>
                                            <li>・ 제과제빵기능사</li>
                                            <li>・ 스포츠지도사</li>
                                            <li>・ SMAT(서비스경영자격)</li>
                                            <li>・ 투자자산운용사</li>
                                            <li>・ 피부미용사</li>
                                            <li>・ 네일미용사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h398">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-major.png"
                                                alt="전공 자격증" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-major@3x.png"
                                                alt="전공 자격증" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">전공 자격증</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list">
                                            <li>・ 전기기사</li>
                                            <li>・ 전산세무1,2급</li>
                                            <li>・ 산업안전기사</li>
                                            <li>・ 전산회계1,2급</li>
                                            <li>・ 건축기사</li>
                                            <li>・ 사회복지사</li>
                                            <li>・ 토목기사</li>
                                            <li>・ 물류관리사</li>
                                            <li>・ 재경관리사</li>
                                            <li>・ 유통관리사</li>
                                            <li>・ 회계관리1,2급</li>
                                            <li>・ 국제무역사</li>
                                            <li>・ 건설안전기사</li>
                                            <li>・ 굴착기운전기능사</li>
                                            <li>・ 지게차운전기능사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h398">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-9.png"
                                                alt="9급 공무원" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-9@3x.png"
                                                alt="9급 공무원" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">9급 공무원</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 일반행정직 / 교육행정직</li>
                                            <li>・ 사회복지직 / 계리직</li>
                                            <li>・ 세무직 / 관세직 / 출입국관리직</li>
                                            <li>・ 법원직 / 검찰직 / 마약수사직</li>
                                            <li>・ 교정직 / 보호직 / 철도경찰직</li>
                                            <li>・ 선거행정직 / 속기직 / 통계직</li>
                                            <li>・ 고용노동직 / 직업상담직</li>
                                            <li>・ 토목직 / 건축직 / 농업직</li>
                                            <li>・ 전기직 / 기계직 / 전산직</li>
                                            <li>・ 환경직 / 보건직 / 의료기술직</li>
                                            <li>・ 시설관리직 / 방호직 / 운전직</li>
                                            <li>・ 지역인재</li>
                                            <li>・ 군무원</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h272">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-7.png"
                                                alt="7급 공무원" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-7@3x.png"
                                                alt="7급 공무원" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">7급 공무원</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 일반행정직 / 교육행정직</li>
                                            <li>・ 세무직 / 회계직</li>
                                            <li>・ 검찰사무직 / 교정직</li>
                                            <li>・ 출입국관리직 / 철도경찰직</li>
                                            <li>・ 선거행정직 / 고용노동직</li>
                                            <li>・ 감사직 / 통계직</li>
                                            <li>・ 인사조직</li>
                                            <li>・ 재경직</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h272">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-8.png"
                                                alt="8급 공무원" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-8@3x.png"
                                                alt="8급 공무원" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">8급 공무원</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 간호직 </li>
                                            <li>・ 보건진료직</li>
                                            <li>・ 국회직</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h272">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-police.png"
                                                alt="경찰 공무원" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-police@3x.png"
                                                alt="경찰 공무원" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">경찰 공무원</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 일반 순경</li>
                                            <li>・ 101 경비단</li>
                                            <li>・ 전의경 경채</li>
                                            <li>・ 경찰행정학과 경채</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h167">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-fire.png"
                                                alt="소방 공무원" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-fire@3x.png"
                                                alt="소방 공무원" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">소방 공무원</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 소방 공채</li>
                                            <li>・ 구급•구조 경채 </li>
                                            <li>・ 소방학과 경채</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h167">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_language.png"
                                                alt="어학" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_language@3x.png"
                                                alt="어학" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">어학</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ TOEIC</li>
                                            <li>・ TOPIK I,II</li>
                                            <li>・ 무역영어</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h167">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_transfer.png"
                                                alt="편입" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_transfer@3x.png"
                                                alt="편입" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">편입</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 대학 편입</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h146">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_guard.png"
                                                alt="부사관/ROTC" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_guard@3x.png"
                                                alt="부사관/ROTC" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">부사관/ROTC</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list">
                                            <li>・ 육군부사관</li>
                                            <li>・ 해군부사관</li>
                                            <li>・ 공군부사관</li>
                                            <li>・ ROTC·학사장교</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="sub_tit">교육담당자 <br class="m_hidden">후기</div>
                    <div class="con">
                        <div class="txt txt_line2">선택=합격, 취업 마스터! 에듀윌 대학 취업교육</div>
                        <div class="section-review">
                            <div class="crown">
                                <ul>
                                    <li class="crown-1">
                                        <span>콘텐츠 만족도 <em>97%</em></span>
                                    </li>
                                    <li class="crown-2">
                                        <span>응대 만족도 <em>99%</em></span>
                                    </li>
                                    <li class="crown-3">
                                        <span>지인 추천 의향 <em>97%</em></span>
                                    </li>
                                </ul>
                                <div class="desc">*2021 에듀윌 온라인 화상교육 진행 대학 대상 설문조사 결과 </div>
                            </div>

                            <div class="item-slick item-slick-sub h394">
                                <div class="slick-inner">
                                    <div class="box">
                                        <div class="text-1">교육의 시작부터 끝까지 꼼꼼하게 준비되어 있어요.</div>

                                        <div class="text-2">비대면 교육 관리에 대한 지식이 전혀 없어서 걱정했는데,<br>
                                            <span>강의 전과 종료 시까지 운영에 필요한 전반적인 제반 사항과 진행 과정이 꼼꼼하게 준비되어
                                                좋았습니다. 초보자들을 위한 기초반과 다양한 문제 풀이를 통해 전략적 접근을 도운
                                                심화반으로</span> <span>단계별 운영이 가능해</span> 좋았습니다.</div>
                                        <div class="who">
                                            숙명여자대학교 취업 교육 담당자
                                        </div>
                                        <div class="img img-4"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/roll-img-04.png">
                                        </div>
                                    </div>
                                </div>
                                <div class="slick-inner">
                                    <div class="box">
                                        <div class="text-1">전문 강사님의 역량, 그리고 담당자의 빠른 피드백까지!</div>

                                        <div class="text-2">현장에서 궁금하거나 필요한 사항이 있을 때 에듀윌 담당자님께서 빠르게 응답해주셔서
                                            어려움 없이 프로그램을 진행할 수 있었습니다.
                                            <span>대학에서 교육 프로그램을 기획하고 운영하는 입장에서 이 보다 좋은 점은 없다고 생각합니다!</span>
                                            더불어 강사님도 훌륭한 강의력은 물론이고 합격 노하우까지 가르쳐주셔서 매우 만족스러웠습니다. </div>
                                        <div class="who">
                                            전주대학교 취업 교육 담당자
                                        </div>
                                        <div class="img img-5"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/roll-img-05.png">
                                        </div>
                                    </div>
                                </div>
                                <div class="slick-inner">
                                    <div class="box">
                                        <div class="text-1">다년간의 데이터로 쌓아 온 에듀윌만의 교육 노하우를 느꼈습니다.</div>

                                        <div class="text-2">에듀윌과 서비스를 진행해 본 결과, 에듀윌이 지난 다년간의 데이터를 통해 다양한 콘텐츠(교육)를
                                            개발하고 진행하면서 가지고 있는 노하우, 방법, 서비스 제공 등의 측면에서
                                            <span>확실히 퀄리티있는 좋은 프로그램을 제공한다는 것을 느꼈습니다!</span></div>
                                        <div class="who">
                                            상지대학교 취업 교육 담당자
                                        </div>
                                        <div class="img img-6"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/roll-img-06.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="sec none-padding">
                    <div class="sub_tit">취업 성공 시크릿</div>
                    <div class="con">
                        <div class="txt">가장 빠른 취업 성공 시크릿, 합격을 부르는 명품 강의!</div>
                        <div class="video_player">
                            <div class="view_thumb">
                                <div class="tab">
                                    <a class="tablinks" onclick="openPartner(event, 'video01')"
                                        video-url="//img.eduwill.net/resources/b2b/dev/video/BYH-SAMPLE.mp4"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-video-04.png" /></a>
                                    <a class="tablinks" onclick="openPartner(event, 'video02')"
                                        video-url="https://www.youtube.com/embed/Av6oobs5TUE"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-video-02.png" /></a>
                                    <a class="tablinks" onclick="openPartner(event, 'video03')"
                                        video-url="https://www.youtube.com/embed/SjPVbNZBw6g"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-video-03.png" /></a>
                                </div>
                            </div>

                            <div class="view">
                                <div id="video01" class="tabcontent" style="display:block; ">
                                    <div class="control-box blind btn-play" pop-name="videoPop"
                                        video-url="//img.eduwill.net/resources/b2b/dev/video/BYH-SAMPLE.mp4">
                                        <img src="//img.eduwill.net/resources/b2b/dev/images/img-video-04.png">
                                        <div class="btn_play"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/play-button.png"></div>
                                    </div>
                                    <!-- <div class="video_play" style="display: none;"><video
                                            src="//img.eduwill.net/resources/b2b/dev/video/BYH-SAMPLE.mp4"
                                            controls></video></div> -->
                                </div>

                                <div id="video02" class="tabcontent">
                                    <div class="control-box blind btn-play" pop-name="videoPop"
                                        video-url="https://www.youtube.com/embed/Av6oobs5TUE?amp;autoplay=1&amp;playlist=Av6oobs5TUE&amp;loop=1">
                                        <img src="//img.eduwill.net/resources/b2b/dev/images/img-video-02.png">
                                        <div class="btn_play"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/play-button.png"></div>
                                    </div>
                                    <!-- <div class="video_play" style="display: none;"><iframe width="600" height="338"
                                            src="https://www.youtube.com/embed/Av6oobs5TUE" title="YouTube video player"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe></div> -->
                                </div>

                                <div id="video03" class="tabcontent">
                                    <div class="control-box blind btn-play" pop-name="videoPop"
                                        video-url="https://www.youtube.com/embed/SjPVbNZBw6g?amp;autoplay=1&amp;playlist=SjPVbNZBw6g&amp;loop=1">
                                        <img src="//img.eduwill.net/resources/b2b/dev/images/img-video-03.png">
                                        <div class="btn_play"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/play-button.png"></div>
                                    </div>
                                    <!-- <div class="video_play" style="display: none;"><iframe width="600" height="338"
                                            src="https://www.youtube.com/embed/SjPVbNZBw6g" title="YouTube video player"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe></div> -->
                                </div>
                            </div>

                            <div class="video_bg"></div>
                        </div>
                        <div class="vi_slider">
                            <div class="swiper-container" id="vi-role">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide"
                                        video-url="//img.eduwill.net/resources/b2b/dev/video/BYH-SAMPLE.mp4">
                                        <div class="control-box"
                                            onclick="$(this).hide().next('.video_play').show().find('video').get(0).play();">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/img-video-04.png">
                                            <div class="btn_play"><img
                                                    src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                                            </div>
                                        </div>
                                        <div class="video_play" style="display: none;"><video
                                                src="//img.eduwill.net/resources/b2b/dev/video/BYH-SAMPLE.mp4"
                                                controls></video></div>
                                    </div>
                                    <div class="swiper-slide"
                                        video-url="https://www.youtube.com/embed/Av6oobs5TUE?enablejsapi=1">
                                        <div class="video_play"><iframe width="600" height="338"
                                                src="https://www.youtube.com/embed/Av6oobs5TUE"
                                                title="YouTube video player" frameborder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowfullscreen></iframe></div>
                                    </div>
                                    <div class="swiper-slide" video-url="https://www.youtube.com/embed/SjPVbNZBw6g">
                                        <div class="video_play"><iframe width="600" height="338"
                                                src="https://www.youtube.com/embed/SjPVbNZBw6g?enablejsapi=1"
                                                title="YouTube video player" frameborder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowfullscreen></iframe></div>
                                    </div>
                                </div>
                                <!-- Add Arrows -->
                                <div class="vi-button swiper-button-next"></div>
                                <div class="vi-button swiper-button-prev"></div>



                            </div>

                        </div>
                    </div>
                </div>
                <div class="sec">
                    <div class="sub_tit">NCS/인적성</div>
                    <div class="con">
                        <div class="txt">취업 스펙 진단 평가를 통한 평가결과를 기반으로 맞춤형 커리큘럼 설계를 지원합니다.</div>
                        <div class="pic_rayout">
                            <div class="pic_box">
                                <div class="pic_icon">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-ai.png"
                                        alt="AI면접, VR면접" class="pc840hidden" />
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-ai@3x.png"
                                        alt="AI면접, VR면접" class="mobile840hidden" />
                                </div>
                                <div class="pic_tit">AI면접, VR면접</div>
                                <div class="pic_comm">채용 트렌드에 맞춘 AI면접, VR 면접 제공</div>
                            </div>
                            <div class="pic_box">
                                <div class="pic_icon">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-book.png"
                                        alt="교재 최다 보유" class="pc840hidden" />
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-book@3x.png"
                                        alt="교재 최다 보유" class="mobile840hidden" />
                                </div>
                                <div class="pic_tit">교재 최다 보유</div>
                                <div class="pic_comm">유형별ㆍ기업별 맞춤형 교재 최다 보유</div>
                            </div>
                            <div class="pic_box">
                                <div class="pic_icon">
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-test.png"
                                        alt="온라인 모의고사" class="pc840hidden" />
                                    <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-test@3x.png"
                                        alt="온라인 모의고사" class="mobile840hidden" />
                                </div>
                                <div class="pic_tit">온라인 모의고사</div>
                                <div class="pic_comm">온라인 모의고사 제공실전 완벽 대비</div>
                            </div>
                        </div>
                        <div class="img_wrap">
                            <div class="spec_ncs">
                                <img src="//img.eduwill.net/resources/b2b/dev/images/img-ncs-01.png">
                                <img src="//img.eduwill.net/resources/b2b/dev/images/img-ncs-02.png">
                                <img src="//img.eduwill.net/resources/b2b/dev/images/img-ncs-03.png">
                                <img src="//img.eduwill.net/resources/b2b/dev/images/img-ncs-04.png">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sec">
                    <div class="sub_tit">
                        <p class="mx200">위탁교육 학습 사이트</p>
                    </div>
                    <div class="con">
                        <div class="txt">최적화된 위탁교육 전용 학습 사이트에서 빠르고 쉬운 학습이 가능합니다.</div>
                        <div class="course_slider">
                            <div class="swiper-container" id="loading-role">
                                <!-- Additional required wrapper -->
                                <div class="swiper-wrapper">
                                    <!-- Slides -->
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-02-01.png" alt="위탁교육">
                                    </div>
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-02-02.png" alt="위탁교육">
                                    </div>
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-02-03.png" alt="위탁교육">
                                    </div>

                                </div>
                                <!-- If we need pagination -->
                                <div class="swiper-pagination"></div>

                                <!-- If we need navigation buttons 
                            <div class="swiper-button-prev"></div>
                            <div class="swiper-button-next"></div>
                            -->
                            </div>
                            <div class="progress_wrapper">
                                <div class="swiper-counter">
                                    <span class="current">1</span> / <span class="total">0</span>
                                </div>
                                <div class="swiper-progress-bar">
                                    <div class="progress"></div>
                                    <div class="progress-sections"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="sub_tit">학습지원</div>
                    <div class="con">
                        <div class="txt">1:1 학습문의 게시판부터 학습활성화 이벤트까지, 에듀윌은 언제나 열려있습니다.</div>
                        <div class="img_wrap">
                            <img src="//img.eduwill.net/resources/b2b/dev/images/01_02_edu_1.png" alt="1:1 학습문의 게시판"
                                style="margin-right:9px;" />
                            <img src="//img.eduwill.net/resources/b2b/dev/images/01_02_edu_2.png" alt="1:1 이벤트" />
                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="clearfix">
                        <div class="sub_tit">대학 위탁교육 Flow</div>
                    </div>
                    <div class="con_wide">
                        <div class="flow_common flow_m_hidden">
                            <div class="f_wrap">
                                <div class="step01 aos-item" data-aos="fade-right" data-aos-delay="300"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01.png" alt="대학" />
                                </div>
                                <div class="step02 flow_line aos-item" data-aos="fade-right" data-aos-delay="450"
                                    data-aos-offset="0">
                                    <div class="text">교육비 지원,위탁</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">학습사이트 지원/운영보고</div>
                                </div>
                                <div class="step03 step_edu aos-item" data-aos="fade-right" data-aos-delay="600"
                                    data-aos-offset="0">
                                    <div class="step_edu_con">
                                        <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                        <p>에듀윌</p>
                                    </div>
                                </div>
                                <div class="step04 flow_line aos-item" data-aos="fade-right" data-aos-delay="750"
                                    data-aos-offset="0">
                                    <div class="text">학습상담/지원</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">강좌 수강/학습 문의</div>
                                </div>
                                <div class="step05 aos-item" data-aos="fade-right" data-aos-delay="900"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-03.png" alt="재학생" />
                                </div>
                            </div>
                        </div>

                        <!-- flow Mobile  -->
                        <div class="flow_common flow_pc_hidden">
                            <div class="f_wrap">
                                <div class="wide">
                                    <div class="step_edu aos-item" data-aos="fade-right" data-aos-delay="450"
                                        data-aos-offset="0">
                                        <div class="step_edu_con">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                            <p>에듀윌</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="stepper">
                                    <div class="img_left aos-item" data-aos="fade-right" data-aos-delay="300"
                                        data-aos-offset="0">
                                        <div class="flow_mo_left">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow01_2_left.png" />
                                        </div>
                                    </div>
                                    <div class="img_right aos-item" data-aos="fade-right" data-aos-delay="600"
                                        data-aos-offset="0">
                                        <div class="flow_mo_right">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow01_2_right.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sub_partner">
                <div class="container">
                    <div class="title_line">
                        <div class="pa_tit">Partner</div>
                        <div class="text">에듀윌과 함께하는 취업교육 파트너 대학입니다.</div>
                    </div>
                    <ul class="pa_slider_scroll">
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_61.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_19_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_20_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_62.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_63.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_64.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_65.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_21_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_22_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_66.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_67.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_68.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_69.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_70.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_71.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_72.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_73.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_23_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_74.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_75.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_76.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_77.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_24_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_78.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_79.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_80.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_25_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_26_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_27_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_28_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_81.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_82.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_83.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_84.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_85.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_86.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_87.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_88.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_89.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/college/ci_90.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_29_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_30_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_31_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_2/ci_32_220711.png" /></li>
                    </ul>
                </div>

            </div>
        </div>
        <!-- 비디오 팝업 -->
    <div class="popup video-popup" id="videoPop">
        <a class="btn-close popClose" href="javascript:;">팝업닫기</a>

        <div class="video-cont"></div>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "UniEduSell",
	components: {SubHeader},
	data() {
		return {}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		var swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        /*
	        autoplay: {
	          delay: 4000,
	          disableOnInteraction: false
	        },*/
	        
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		// 파트너 슬라이더
		$(".tablinks").on("click",function(){
			$('.pa_slider').slick('setPosition');
			$('.pa_slider').slick('goTo', 0);
		});
	
		$(".pa_slider_scroll").simplyScroll({
			customClass:'vert',
			speed: 5,
			pauseOnHover : true
		});
	},
}
</script>

<style scoped>
	.element_to_pop_gal { display:none; }
</style>
